<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <info-table
          roleLinkField="officialRoles"
          updatePermissions="PROFILE.UPDATE"
          :profile="profile"
          :login="login"
          @showEditModal="showEditModal"
        />
      </v-flex>
    </v-layout>

    <modal :show="showModal" :id="editId" :edit="!!editId" @close="hideModal" @update="update" />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

import { modalMixin } from '@/mixins/modal';
import store from '@/store/store';
import infoTable from '../profile/InfoTable';
import Modal from './modals/Manage';

/**
 * @vuese
 * Profil
 * @group officials
 */
export default {
  components: { infoTable, Modal },
  mixins: [
    modalMixin('officials', {
      getError: 'Wystąpił błąd podczas pobierania danych operatora.',
      updated: 'Zaktualizowano dane operatora.',
      updateError: 'Nie udało się zaktualizować danych operatora.'
    })
  ],
  props: {
    // id edytowanego profilu jeśli istnieje
    editProfileId: {
      type: Number,
      required: false,
      default: 0
    }
  },
  computed: {
    ...mapState({
      profile: state => state.officials.data.profile,
      login: state => state.officials.data.login,
      id: state => state.officials.data.profile.id
    }),
    editId() {
      if (this.editProfileId) {
        return this.editProfileId.toString();
      } else {
        return this.id.toString();
      }
    }
  }
};
</script>
